// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1xByp","label":"Completed_label__3619W"};